import { render } from "./customField.vue?vue&type=template&id=5519893a&scoped=true"
import script from "./customField.vue?vue&type=script&lang=js"
export * from "./customField.vue?vue&type=script&lang=js"

import "./customField.vue?vue&type=style&index=0&id=5519893a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5519893a"]])

export default __exports__